import Vue from 'vue'
import Vuex from 'vuex'
import login from "./modules/login"
import news from "./modules/news"
import course from "./modules/course"
import user from "./modules/user"
import basics from "./modules/basics"
Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    resetState({
      commit
    }) {
      commit('resetModuleState');
    }
  },
  modules: {
    login,
    news,
    course,
    user,
    basics
  }
})